export default __webpack_public_path__ + "static/media/069.a931964e.jpg";